// --------------------------------------------------------
// APPOINTMENT LIST ITEM - AppointmentListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Avatar, Tooltip } from "@mui/material";
import React, { useState } from "react";
import Colors from "../../constants/Colors";
import { ReactComponent as Clock } from "../../assets/imgs/clockIcon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/imgs/calendarIcon.svg";
import { ReactComponent as CalendarCheck } from "../../assets/imgs/calendarCheck.svg";
import {
  HourContainer,
  MobileContainer,
} from "../../pages/appointmentPanel/AppointmentPanel.styled";
import AppointmentAttendance from "../appointmentAttendance/AppointmentAttendance";
import { Text } from "../UI/generalLayout/Layout.styled";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import * as appointmentActions from "../../store/actions/appointment";
import { useAppDispatch } from "../..";
import { AppointmentListItemContainer } from "./AppointmentListItem.styled";
import { convertDayToMoment } from "../../helpers/HelperFunctions";
import useFetchPhoto from "../../hooks/useFetchPhoto";
import { AppointmentStatus } from "../../enums/AppointmentStatus";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// APPOINTMENT LIST ITEM INTERFACE
// --------------------------------------------------------

interface IAppointmentListItem {
  appointment: any;
  updateList: any;
  selectedDate: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AppointmentListItem = ({ appointment, updateList, selectedDate }: IAppointmentListItem) => {
  // --------------------------------------------------------
  // APPOINTMENT LIST ITEM PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [photo, setPhoto] = useState<any>();
  const dispatch = useAppDispatch()
  // --------------------------------------------------------
  const onAttendanceStatusClick = async (status: string) => {
    try {
      await dispatch(appointmentActions.updateAttendanceStatus(appointment.agendamentoId, status));
      updateList();
    } catch (error: any) {

    }
  }

  const paciente = appointment.paciente;
  const profissional = appointment.profissional;
  const statusPresenca = appointment.statusPresenca;
  const isEncaixe = appointment.encaixe;
  const horario = appointment.horario.substring(0, 5);

  const { isMobile } = useResponsiveInfo();
  
  useFetchPhoto(paciente? paciente.foto: null, setPhoto)

  const isConfirmed = statusPresenca === AppointmentStatus.C;

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {!isMobile ? (
        <AppointmentListItemContainer isEncaixe={isEncaixe}>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              flex: 1.5,
              minWidth: 0,
            }}
          >
            {isConfirmed ? (
              <Tooltip title="Consulta Confirmada">
                <CalendarCheck style={{ marginRight: 10, cursor: 'default', color: Colors.SPM600, minWidth: 24 }} />
              </Tooltip>
            ) : (
              <Tooltip title="Confirmação Pendente">
                <CalendarIcon style={{ marginRight: 10, cursor: 'default', color: Colors.SPM600, minWidth: 24 }} />
              </Tooltip>
            )}
            <Avatar style={{ marginRight: 8 }} src={photo} />
            {!isEncaixe && <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{paciente ? paciente.nome: ''}</Text>}

            {isEncaixe && (
              <div style={{ flexDirection: "column", display: "flex", minWidth: 0 }}>
                <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {paciente ? paciente.nome: ''}
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    color: Colors.SPM600,
                    margin: 0,
                  }}
                >
                  Encaixe
                </Text>
              </div>
            )}
          </div>
          <div style={{ width: 120, display: 'flex', justifyContent: 'center' }}>
            <HourContainer>
              <Clock />
              <Text
                style={{ fontSize: 14, marginLeft: 5, color: Colors.SPM600, margin: 0 }}
              >
                {horario}
              </Text>
            </HourContainer>
          </div>
          <div style={{ flex: 1, minWidth: 0, paddingLeft: 10, display: 'flex', alignItems: 'center' }}>
            <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{profissional.nome}</Text>
          </div>
          <div style={{ flex: 1, minWidth: 0, paddingLeft: 10, display: 'flex', alignItems: 'center' }}>
            <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{`Consulta ${appointment.tipoConsulta}`}</Text>
          </div>
          <div style={{ width: 150, display: 'flex', justifyContent: 'flex-end' }}>
            <AppointmentAttendance
              onChangeStatus={onAttendanceStatusClick}
              status={statusPresenca}
              selectedDate={selectedDate}
            />
          </div>
        </AppointmentListItemContainer>
      ) : (
        <>
          <MobileContainer
            style={{ backgroundColor: isEncaixe ? "#E7F3FD" : "#FAFAFA" }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flexDirection: "row", display: "flex", alignItems: 'center', flex: 1, minWidth: 0 }}>
                {isConfirmed ? (
                  <CalendarCheck style={{ marginRight: 8, width: 20, height: 20, color: Colors.SPM600, minWidth: 20 }} />
                ) : (
                  <CalendarIcon style={{ marginRight: 8, width: 20, height: 20, color: Colors.SPM600, minWidth: 20 }} />
                )}
                <Avatar style={{ marginRight: 8 }} src={photo} />
                {!isEncaixe && <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{paciente ? paciente.nome: ''}</Text>}

                {isEncaixe && (
                  <div style={{ flexDirection: "column", display: "flex", minWidth: 0 }}>
                    <Text style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {paciente ? paciente.nome: ''}
                    </Text>
                    <Text
                      style={{
                        fontSize: 13,
                        color: Colors.SPM600,
                        margin: 0,
                      }}
                    >
                      Encaixe
                    </Text>
                  </div>
                )}
              </div>
              <HourContainer>
                <Clock />
                <Text
                  style={{ fontSize: 14, marginLeft: 5, color: Colors.SPM600 }}
                >
                  {horario}
                </Text>
              </HourContainer>
            </div>
            <AppointmentAttendance
              onChangeStatus={onAttendanceStatusClick}
              status={statusPresenca}
              selectedDate={selectedDate}
            />
          </MobileContainer>
        </>
      )}
    </>
  );
  // --------------------------------------------------------
};

export default AppointmentListItem;
